export default __webpack_public_path__ + "images/assets/38cf92af3962f5462f60ed52dd3b865c.svg";